<template>Logout</template>
<script>
export default {
  name: 'Logout',
  async created() {
    console.log('hit');
    const logoutRes = await this.$store.dispatch('users/userSignOut');
    if (logoutRes) {
      this.$router.push({ name: 'SignUp' });
    }
  },
};
</script>
